<template>
    <q-card class="bg-secondary full-height" style="min-height: 200px;">
        <q-card-main class="text-white">
            <div class="row gutter-md">
                <div class="col-5 text-center">
                    <q-icon size="5rem" :name="icon" />
                    <p class="q-pt-sm module-names">
                        {{ getModuleTitle(module_type) }}
                    </p>
                </div>
                <div class="col-7">
                    <div class="row">
                        <div class="col-12 q-mb-sm" v-if="active != null">
                            <div class="iCountUp">
                                {{ active_lb }} <ICountUp :endVal="active" :options="options" />
                            </div>
                        </div>

                        <div class="col-12 q-mb-sm" v-if="inactive != null">
                            <div class="iCountUp">
                                {{ inactive_lb }} <ICountUp :endVal="inactive" :options="options" />
                            </div>
                        </div>

                        <div class="col-12 q-mb-sm" v-if="deleted != null">
                            <div class="iCountUp">
                                {{ deleted_lb }} <ICountUp :endVal="deleted" :options="options" />
                            </div>
                        </div>

                        <div class="col-12 q-mb-sm" v-if="pre_registered != null">
                            <div class="iCountUp">
                                {{ self_registered_lb }} <ICountUp :endVal="self_registered" :options="options" />
                            </div>
                        </div>

                        <div class="col-12 q-mb-sm" v-if="pre_registered != null">
                            <div class="iCountUp">
                                {{ pre_registered_lb }} <ICountUp :endVal="pre_registered" :options="options" />
                            </div>
                        </div>

                        <div class="col-12 q-mb-sm" v-if="others != null">
                            <div class="iCountUp">
                                {{ others_lb }} <ICountUp :endVal="others" :options="options" />
                            </div>
                        </div>

                        <div class="col-12 q-mb-sm" v-if="certificates != null">
                            <div class="iCountUp">
                                {{ certificates_lb }} <ICountUp :endVal="certificates" :options="options" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </q-card-main>
    </q-card>
</template>

<script>
import { mapGetters } from 'vuex'

import ICountUp from 'vue-countup-v2'

export default {
    name: 'AdminOverviewDashboardTotals',

    props: ['title', 'icon', 'active', 'active_lb', 'inactive', 'inactive_lb', 'deleted', 'deleted_lb', 'certificates', 'certificates_lb', 'self_registered_lb', 'self_registered', 'pre_registered_lb', 'pre_registered', 'others_lb', 'others', 'module_type'],

    components: {
        ICountUp
    },

    data () {
        return {
            endVal: 120500,
            options: {
                useEasing: true,
                useGrouping: true,
                separator: ',',
                decimal: '.',
                prefix: '',
                suffix: ''
            },
            module_titles: {
                live_classes: 'live_classes',
                presentials: 'presential',
                trails: 'trails',
                trainings: 'trainings',
                users: 'users',
                webcasts: 'webcasts'
            }
        }
    },

    computed: {
        ...mapGetters({
            clients: 'params/clients',
            id_user_client_selected: 'common/id_user_client_selected',
        }),
    },

    methods: {
        onReady: function(instance, CountUp) {
            const that = this
            instance.update(that.endVal + 100)
        },

        getModuleNames() {
            if (this.id_user_client_selected) {
                let obj = this.clients.find((obj) => { return obj.id === this.id_user_client_selected })
                if (obj) {
                    this.module_titles.live_classes = obj.title_live_classes ? obj.title_live_classes : 'live_classes'
                    this.module_titles.presential = obj.title_presential ? obj.title_live_presential : 'presential'
                    this.module_titles.trainings = obj.title_trainings ? obj.title_trainings : 'trainings'
                    this.module_titles.trails = obj.title_trails ? obj.title_trails : 'trails'
                    this.module_titles.webcasts = obj.title_webcasts ? obj.title_webcasts : 'live'

                }
            }
        },

        getModuleTitle(type) {
            if (type === 'live_class') return this.$t(this.module_titles.live_classes)
            if (type === 'presential') return this.$t(this.module_titles.presentials)
            if (type === 'training') return this.$t(this.module_titles.trainings)
            if (type === 'trails') return this.$t(this.module_titles.trails)
            if (type === 'users') return this.$t('users')
            if (type === 'webcast') return this.$t(this.module_titles.webcasts)
        }
    },

    mounted () {
        this.getModuleNames()
    },
}
</script>

<style lang="stylus" scoped>
.iCountUp
    font-size 1.5em

.module-names
    font-size 1.5em
</style>
